import React from 'react'
import './Footer.css'
// import { Button } from './Button'
// import Button from 'react-bootstrap/Button'
// import { Link } from 'react-router-dom'

function Footer () {
  return (
    <div className='footer-container'>
      <section className='social-media'>
        <small className='website-rights'>haiku75. © 2021</small>
      </section>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js